module.exports = __webpack_public_path__ + "img/4d36591.png";